import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_english_v = _resolveComponent("english-v")!
  const _component_accordion = _resolveComponent("accordion")!
  const _component_Sentences = _resolveComponent("Sentences")!
  const _component_ChooseType = _resolveComponent("ChooseType")!
  const _component_Finish = _resolveComponent("Finish")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ModalForImage = _resolveComponent("ModalForImage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.stateWords == 'englishV')
            ? (_openBlock(), _createBlock(_component_english_v, {
                key: 0,
                len: _ctx.executeWords.length,
                "task-num": _ctx.route.query.task,
                onPreviousTask: _ctx.previousTask,
                onNextTask: _ctx.nextTask,
                onSetFinishType: _ctx.setFinishType
              }, null, 8, ["len", "task-num", "onPreviousTask", "onNextTask", "onSetFinishType"]))
            : (_ctx.stateWords == 'accordion')
              ? (_openBlock(), _createBlock(_component_accordion, { key: 1 }))
              : (_ctx.stateWords == 'sentences')
                ? (_openBlock(), _createBlock(_component_Sentences, { key: 2 }))
                : (_ctx.stateWords == 'start')
                  ? (_openBlock(), _createBlock(_component_ChooseType, {
                      key: 3,
                      onSetCurrentType: _ctx.setCurrentType
                    }, null, 8, ["onSetCurrentType"]))
                  : (_ctx.stateWords == 'finish')
                    ? (_openBlock(), _createBlock(_component_Finish, {
                        key: 4,
                        len: _ctx.executeWords.length
                      }, null, 8, ["len"]))
                    : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Loader)
        ])),
    _createVNode(_component_ModalForImage)
  ], 64))
}